import TeamsRoute from './TeamsRoute';

export default TeamsRoute;
